import React, { useState } from "react";
import styled from "styled-components";
import { Form, Row, Col } from "antd";
import { Input, Button, Typography, Loading } from "../../core";
import { MixStyle } from "../../styles";
import { addClothQuality } from "../../helper/utils/api/settings";

const layout = {
  labelCol: {
    span: 24,
  },

  wrapperCol: {
    span: 24,
  },
};

const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;

const AddCloth = ({ getClothQualities, closeModal, ...rest }) => {
  const companyId = localStorage.getItem("companyId");
  const [clothQulaity, setClothQuality] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();

  const onValuesChange = (changedValues, newClothQuality) => {
    const { warp, weft, reed, pick, width, type } = newClothQuality;

    setClothQuality((prev) => ({
      ...prev,
      companyId,
      warp,
      weft,
      reed,
      pick,
      width,
      type,
    }));
  };

  const closeModalHandler = () => {
    closeModal("addClothQaulityModal");
  };

  const onFinish = (values) => {
    createClothQuality();
  };

  const createClothQuality = async () => {
    console.log("clothQulaity=>", clothQulaity);
    setIsLoading(true);

    try {
      await addClothQuality(clothQulaity);
      closeModalHandler();
      getClothQualities();
    } catch (error) {
      console.log("error add cloth quality", error.response.data.message);
    }

    setIsLoading(false);
  };

  const onFinishFailed = () => {};

  return (
    <div>
      {isLoading ? <Loading /> : null}
      <StyledForm
        autocomplete="off"
        form={form}
        {...layout}
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        onValuesChange={onValuesChange}
      >
        <Row
          gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
          type="flex"
          justify="center"
        >
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Warp"
              name="warp"
              rules={[
                {
                  required: true,
                  message: "Please input Warp!",
                },
              ]}
            >
              <Input type="number" placeholder="Warp" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Weft"
              name="weft"
              rules={[
                {
                  required: true,
                  message: "Please input weft!",
                },
              ]}
            >
              <Input type="number" placeholder="Weft" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Reed"
              name="reed"
              rules={[
                {
                  required: true,
                  message: "Please input Reed!",
                },
              ]}
            >
              <Input type="number" placeholder="Reed" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Pick"
              name="pick"
              rules={[
                {
                  required: true,
                  message: "Please input pick!",
                },
              ]}
            >
              <Input type="number" placeholder="Pick" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Width"
              name="width"
              rules={[
                {
                  required: true,
                  message: "Please input width!",
                },
              ]}
            >
              <Input type="number" placeholder="Width" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Type"
              name="type"
              rules={[
                {
                  required: true,
                  message: "Please input type!",
                },
              ]}
            >
              <Input placeholder="Type" />
            </Form.Item>
          </Col>
          <Col xs={18}>
            <Row type="flex" justify="space-between">
              <Col sm={10}>
                <Button bg="#404E67" type="primary" htmlType="submit">
                  <Typography
                    text="Add"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
              <Col sm={10}>
                <Button bg="#404E67" type="primary" onClick={closeModalHandler}>
                  <Typography
                    text="cancel"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </StyledForm>
    </div>
  );
};

export default AddCloth;
